/* KonpreShop · Inicio de tienda (sections/ks-tienda-inicio.liquid), 31-oct-2026.
   Un selector manda a todas las copias de la sección en la página: pestañas de productos, categorías y marcas
   cambian sin recargar. Productos por la Section Rendering API (?section_id=ks-tienda-rejilla). Sin librerías.
   Modo «genero»: /collections/<col>/genero:<g>. Modo «coleccion»: la opción elegida ES la colección (estilo, disciplina…).
   Extras por tienda: «Arma tu estimado» (SportShop) y el cotizador corto de MaquilaDTF (los dos solo arman un mensaje). */
(function () {
  if (window.ksTiendaInicio) return;
  window.ksTiendaInicio = true;
  var KEY = 'ks-genero';
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {};
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function roots() { return $$('[data-kti]'); }
  function first() { return roots()[0]; }
  function modo() { var r = first(); return (r && r.getAttribute('data-modo')) || 'genero'; }
  function nombre(g) {
    if (!g) return '';
    if (g === 'hombre') return 'Hombre';
    if (g === 'mujer') return 'Mujer';
    var b = document.querySelector('[data-kti-g="' + g + '"][data-label]');
    return b ? b.getAttribute('data-label') : '';
  }
  function money(n) {
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  /* liga de la colección de una pestaña según la elección */
  function urlFor(tab, g, q) {
    var col = tab.getAttribute('data-col'), f = tab.getAttribute('data-filtro');
    if (f) q += (q.indexOf('?') < 0 ? '?' : '&') + f;
    if (modo() === 'coleccion') return '/collections/' + (g || col) + q;
    return '/collections/' + col + (g ? '/genero:' + g : '') + q;
  }

  /* ---------- productos ---------- */
  function ghost(n) {
    var h = '';
    for (var i = 0; i < n; i++) h += '<div class="kti-ghost" aria-hidden="true"><span></span><i></i><i></i></div>';
    return h;
  }
  function setAll(prod, tab, g, count) {
    var t = tab.getAttribute('data-titulo');
    var href = urlFor(tab, g, '?view=todo');
    var where = (modo() === 'coleccion' && g) ? nombre(g) : t;
    $$('[data-kti-all]', prod).forEach(function (a) {
      a.href = href;
      var s = a.querySelector('[data-kti-all-t]');
      if (s) s.textContent = 'Ver ' + (count ? 'los ' + count + ' ' : 'todo ') + 'en ' + where;
    });
    var n = tab.querySelector('[data-kti-tab-n]');
    $$('[data-kti-tab-n]', prod).forEach(function (x) { x.textContent = ''; });
    if (n && count) n.textContent = count;
  }
  function otherTab(prod, tab) {
    return $$('[data-kti-tab]', prod).filter(function (t) { return t !== tab; })[0];
  }
  function trim(grid, root) {
    var lim = parseInt(root.getAttribute('data-limite'), 10) || 8;
    $$('.kti-card', grid).forEach(function (c, i) { if (i >= lim) c.remove(); });
  }
  function render(prod, tab, g, html, count) {
    var grid = prod.querySelector('[data-kti-grid]');
    grid.setAttribute('aria-busy', 'false');
    if (!html || !/kti-card/.test(html)) {
      var o = otherTab(prod, tab);
      grid.innerHTML = '<div class="kti-msg"><p>Todavía no hay ' + tab.getAttribute('data-titulo') + (g ? ' para ' + nombre(g) : '') + '.</p>' +
        (o ? '<button type="button" class="kti-btn kti-btn--glass" data-kti-goto="' + o.id + '">Ver ' + o.getAttribute('data-titulo') + '</button>' : '') + '</div>';
      setAll(prod, tab, g, 0);
      return;
    }
    grid.innerHTML = html;
    trim(grid, prod.closest('[data-kti]'));
    if (!still) { grid.classList.remove('is-in'); void grid.offsetWidth; grid.classList.add('is-in'); }
    setAll(prod, tab, g, count);
  }
  function load(prod, tab, g, silent) {
    var grid = prod.querySelector('[data-kti-grid]');
    var sort = tab.getAttribute('data-sort');
    var url = urlFor(tab, g, '?section_id=ks-tienda-rejilla' + (sort && sort !== 'manual' ? '&sort_by=' + sort : ''));
    var key = url;
    grid.setAttribute('aria-labelledby', tab.id);
    if (cache[key]) { render(prod, tab, g, cache[key].html, cache[key].count); return; }
    if (!silent) {
      grid.style.minHeight = grid.offsetHeight ? grid.offsetHeight + 'px' : '';
      grid.innerHTML = ghost(Math.min(8, parseInt(prod.closest('[data-kti]').getAttribute('data-limite'), 10) || 8));
      grid.setAttribute('aria-busy', 'true');
    }
    prod.setAttribute('data-req', key);
    fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var box = doc.querySelector('[data-kti-rejilla]');
      var res = { html: box ? box.innerHTML.trim() : '', count: box ? parseInt(box.getAttribute('data-count'), 10) || 0 : 0 };
      cache[key] = res;
      if (prod.getAttribute('data-req') !== key) return; // ya pidieron otra cosa
      render(prod, tab, g, res.html, res.count);
      grid.style.minHeight = '';
    }).catch(function () {
      if (prod.getAttribute('data-req') !== key) return;
      grid.setAttribute('aria-busy', 'false');
      grid.style.minHeight = '';
      grid.innerHTML = '<div class="kti-msg"><p>No pudimos cargar esta lista.</p><button type="button" class="kti-btn kti-btn--glass" data-kti-retry>Reintentar</button>' +
        '<a class="kti-link" href="' + urlFor(tab, g, '?view=todo') + '"><span>Ir al catálogo</span></a></div>';
    });
  }
  function activeTab(prod) { return prod.querySelector('[data-kti-tab][aria-selected="true"]') || prod.querySelector('[data-kti-tab]'); }
  function selectTab(prod, tab, focus) {
    $$('[data-kti-tab]', prod).forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    if (focus) tab.focus();
    load(prod, tab, state.g);
  }

  /* ---------- selector ---------- */
  var state = { g: '' };
  function apply(g, opts) {
    opts = opts || {};
    state.g = g;
    var m = modo();
    roots().forEach(function (root) {
      root.setAttribute('data-genero', g);
      $$('[data-kti-g]', root).forEach(function (b) {
        var on = b.getAttribute('data-kti-g') === g;
        var was = b.getAttribute('aria-pressed') === 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && !was && !still && b.classList.contains('kti-pill--fig')) {
          b.classList.remove('is-walk'); void b.offsetWidth; b.classList.add('is-walk');
        }
      });
      if (m === 'genero') {
        $$('.kti-cats__item', root).forEach(function (li) {
          var gr = li.getAttribute('data-grupo');
          li.hidden = !(g ? gr === g : gr === 'todo');
        });
        var gn = root.querySelector('[data-kti-gname]');
        if (gn) gn.textContent = g ? ' · ' + nombre(g) : '';
        var track = root.querySelector('[data-kti-track]');
        if (track) { track.scrollLeft = 0; arrows(root); }
        var base = root.getAttribute('data-base');
        $$('[data-kti-marcas] li', root).forEach(function (li) {
          var n = li.getAttribute(g === 'hombre' ? 'data-nh' : g === 'mujer' ? 'data-nm' : 'data-n');
          li.hidden = !(parseInt(n, 10) > 0);
          var a = li.querySelector('a'), c = li.querySelector('[data-kti-n]');
          if (c) c.textContent = n;
          if (a && a.hasAttribute('data-vq') && !a.hasAttribute('data-tiendita')) a.href = base + (g ? '/genero:' + g : '') + '?view=todo&' + a.getAttribute('data-vq');
        });
      }
      var est = root.querySelector('[data-kti-est]');
      if (est && m === 'coleccion') estFiltro(est, g);
      var prod = root.querySelector('[data-kti-prod]');
      if (prod && !opts.skipLoad) load(prod, activeTab(prod), g, opts.silent);
    });
    if (opts.save !== false) {
      if (m === 'genero') { try { if (g) localStorage.setItem(KEY, g); else localStorage.removeItem(KEY); } catch (e) {} }
      try {
        var p = first().getAttribute('data-param') || 'genero';
        var u = new URL(location.href);
        if (g) u.searchParams.set(p, g); else u.searchParams.delete(p);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
  }

  /* ---------- categorías: flechas ---------- */
  function arrows(root) {
    var tr = root.querySelector('[data-kti-track]');
    if (!tr) return;
    var p = root.querySelector('[data-kti-prev]'), n = root.querySelector('[data-kti-next]');
    var max = tr.scrollWidth - tr.clientWidth - 2;
    if (p) p.disabled = tr.scrollLeft <= 2;
    if (n) n.disabled = tr.scrollLeft >= max;
    root.classList.toggle('kti-no-scroll', max <= 0);
  }

  /* ---------- «Arma tu estimado» (SportShop) ---------- */
  function estData(est) {
    var sel = est.querySelector('[data-kti-est-model]');
    var o = sel && sel.options[sel.selectedIndex];
    if (!o) return null;
    try { return { o: o, d: JSON.parse(o.getAttribute('data-p')) }; } catch (e) { return null; }
  }
  function estRows(est) {
    var box = est.querySelector('[data-kti-est-rows]'), x = estData(est);
    if (!box || !x) return;
    var rangos = x.d.rangos || [];
    var max = 0;
    rangos.forEach(function (r) { if (r[2] > max) max = r[2]; });
    box.innerHTML = rangos.map(function (r, i) {
      var w = max ? Math.round(r[2] / max * 100) : 0;
      return '<div class="kti-est__row">' +
        '<div class="kti-est__who"><strong>' + r[0] + '</strong><small>' + r[1] + '</small></div>' +
        '<div class="kti-est__bar" aria-hidden="true"><i style="width:' + w + '%"></i></div>' +
        '<div class="kti-est__pu">' + money(r[2]) + '<small> c/u</small></div>' +
        '<div class="kti-est__step">' +
          '<button type="button" data-kti-est-m aria-label="Quitar una pieza ' + r[0] + '"><svg class="kti-ico" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8h9"/></svg></button>' +
          '<input type="number" min="0" step="1" inputmode="numeric" value="0" data-i="' + i + '" aria-label="Piezas ' + r[0] + ', ' + r[1] + '">' +
          '<button type="button" data-kti-est-p aria-label="Agregar una pieza ' + r[0] + '"><svg class="kti-ico" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8h9M8 3.5v9"/></svg></button>' +
        '</div></div>';
    }).join('');
    estSum(est);
  }
  function estSum(est) {
    var x = estData(est);
    if (!x) return;
    var rangos = x.d.rangos || [], tot = 0, pz = 0, partes = [];
    $$('.kti-est__row input', est).forEach(function (inp) {
      var n = Math.max(0, parseInt(inp.value, 10) || 0), r = rangos[+inp.getAttribute('data-i')];
      if (!r) return;
      tot += n * r[2]; pz += n;
      if (n) partes.push(r[0] + ' (' + r[1] + '): ' + n);
    });
    est.querySelector('[data-kti-est-total]').textContent = money(Math.round(tot * 100) / 100);
    est.querySelector('[data-kti-est-pz]').textContent = pz + (pz === 1 ? ' pieza' : ' piezas');
    var warn = est.querySelector('[data-kti-est-warn]');
    est.classList.toggle('is-ok', pz >= 10);
    warn.textContent = pz >= 10 ? 'Ya llegas al mínimo de 10 piezas.' : 'El pedido mínimo es de 10 piezas' + (pz ? (10 - pz === 1 ? ': te falta 1.' : ': te faltan ' + (10 - pz) + '.') : '.');
    var go = est.querySelector('[data-kti-est-go]');
    if (go) go.href = x.o.getAttribute('data-url');
    var wa = est.querySelector('[data-kti-est-wa]');
    if (wa) {
      var t = 'Hola, quiero cotizar en SportShop: ' + x.o.textContent.trim() + '.' +
        (pz ? ' ' + pz + ' piezas. ' + partes.join('; ') + '. Mi estimado con IVA: ' + money(Math.round(tot * 100) / 100) + '.' : '');
      wa.href = 'https://wa.me/' + est.getAttribute('data-wa') + '?text=' + encodeURIComponent(t);
    }
  }
  function estFiltro(est, g) {
    var sel = est.querySelector('[data-kti-est-model]');
    if (!sel) return;
    var firstOk = -1;
    $$('option', sel).forEach(function (o, i) {
      var ok = !g || (' ' + o.getAttribute('data-disc') + ' ').indexOf(' ' + g + ' ') >= 0;
      o.hidden = !ok; o.disabled = !ok;
      if (ok && firstOk < 0) firstOk = i;
    });
    if (firstOk >= 0 && sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled) { sel.selectedIndex = firstOk; estRows(est); }
    else if (firstOk >= 0 && g) { sel.selectedIndex = firstOk; estRows(est); }
  }

  /* ---------- selector pegado bajo el encabezado ---------- */
  function sticky() {
    var head = document.querySelector('.shopify-section-group-header-group, #shopify-section-header, .site-header');
    var hostOf = function (el) { while (el && el.parentElement && getComputedStyle(el).position !== 'sticky') el = el.parentElement; return el; };
    var host = head ? hostOf(head) : null;
    function setTop() {
      var b = host ? host.getBoundingClientRect().bottom : 0;
      document.documentElement.style.setProperty('--kti-top', Math.max(0, Math.round(b)) + 'px');
    }
    setTop();
    if (host && window.ResizeObserver) new ResizeObserver(setTop).observe(host);
    window.addEventListener('resize', setTop);
    $$('[data-kti-sentinel]').forEach(function (s) {
      var sel = s.nextElementSibling && s.nextElementSibling.matches('[data-kti-sel]') ? s.nextElementSibling : null;
      if (!sel || !window.IntersectionObserver) return;
      var io = null;
      function watch() {
        if (io) io.disconnect();
        var top = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--kti-top'), 10) || 0;
        io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var stuck = !e.isIntersecting && e.boundingClientRect.top < top + 1;
            var root = sel.closest('[data-kti]'), mini = root && root.querySelector('[data-kti-mini]');
            if (root) root.classList.toggle('is-stuck', stuck);
            if (mini) {
              mini.setAttribute('aria-hidden', stuck ? 'false' : 'true');
              $$('button', mini).forEach(function (bt) { bt.tabIndex = stuck ? 0 : -1; });
            }
          });
        }, { rootMargin: '-' + (top + 1) + 'px 0px 0px 0px', threshold: 0 });
        io.observe(sel);
      }
      watch();
      window.addEventListener('resize', watch);
    });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var pick = t.closest('[data-kti-g]');
    if (pick) { e.preventDefault(); apply(pick.getAttribute('data-kti-g')); return; }
    var tab = t.closest('[data-kti-tab]');
    if (tab) { e.preventDefault(); selectTab(tab.closest('[data-kti-prod]'), tab); return; }
    var go = t.closest('[data-kti-goto]');
    if (go) { var tt = document.getElementById(go.getAttribute('data-kti-goto')); if (tt) selectTab(tt.closest('[data-kti-prod]'), tt, true); return; }
    var rt = t.closest('[data-kti-retry]');
    if (rt) { var pr = rt.closest('[data-kti-prod]'); load(pr, activeTab(pr), state.g); return; }
    var st = t.closest('[data-kti-est-m], [data-kti-est-p]');
    if (st) {
      var inp = st.parentNode.querySelector('input');
      inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + (st.hasAttribute('data-kti-est-p') ? 1 : -1));
      estSum(st.closest('[data-kti-est]'));
      return;
    }
    var ar = t.closest('[data-kti-prev], [data-kti-next]');
    if (ar) {
      var tr = ar.closest('[data-kti]').querySelector('[data-kti-track]');
      var step = Math.max(160, tr.clientWidth * 0.8) * (ar.hasAttribute('data-kti-prev') ? -1 : 1);
      tr.scrollBy({ left: step, behavior: still ? 'auto' : 'smooth' });
    }
  });
  document.addEventListener('input', function (e) {
    var est = e.target.closest && e.target.closest('[data-kti-est]');
    if (est && e.target.matches('input')) estSum(est);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-kti-est-model]')) estRows(e.target.closest('[data-kti-est]'));
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-kti-dtf-form]');
    if (!f) return;
    e.preventDefault();
    var box = f.closest('[data-kti-dtf]'), err = f.querySelector('[data-kti-dtf-err]');
    var prenda = f.prenda.value.trim(), tam = f.tamano.value.trim(), pz = parseInt(f.piezas.value, 10) || 0;
    if (!prenda || pz < 1) { err.hidden = false; (prenda ? f.piezas : f.prenda).focus(); return; }
    err.hidden = true;
    var t = (box.getAttribute('data-intro') || 'Hola, quiero cotizar una impresión DTF.') + ' Prenda: ' + prenda + '.' + (tam ? ' Tamaño del diseño: ' + tam + '.' : '') + ' Piezas: ' + pz + '.';
    window.open('https://wa.me/' + box.getAttribute('data-wa') + '?text=' + encodeURIComponent(t), '_blank', 'noopener');
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-kti-tab]');
    if (!tab) return;
    var tabs = $$('[data-kti-tab]', tab.closest('[role="tablist"]'));
    var i = tabs.indexOf(tab), j = -1;
    if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') j = 0;
    else if (e.key === 'End') j = tabs.length - 1;
    if (j < 0) return;
    e.preventDefault();
    selectTab(tab.closest('[data-kti-prod]'), tabs[j], true);
  });

  /* ---------- arranque ---------- */
  function init() {
    var rs = roots();
    if (!rs.length) return;
    var m = modo();
    var hasSel = !!document.querySelector('[data-kti-sel]');
    var g0 = rs[0].getAttribute('data-genero') || '';
    var g = g0;
    var valid = function (v) { return !!v && !!document.querySelector('[data-kti-sel] [data-kti-g="' + v + '"]'); };
    try {
      var q = new URL(location.href).searchParams.get(rs[0].getAttribute('data-param') || 'genero');
      if (valid(q)) g = q;
      else if (m === 'genero' && !g0 && hasSel) { var ls = localStorage.getItem(KEY); if (valid(ls)) g = ls; }
    } catch (e) {}
    rs.forEach(function (root) {
      var tr = root.querySelector('[data-kti-track]');
      if (tr) { arrows(root); tr.addEventListener('scroll', function () { arrows(root); }, { passive: true }); window.addEventListener('resize', function () { arrows(root); }); }
      var est = root.querySelector('[data-kti-est]');
      if (est) estRows(est);
      var grid = root.querySelector('[data-kti-grid]');
      if (grid) trim(grid, root);
    });
    // la página ya viene pintada para g0; si la elección guardada es otra, se cambia (con fantasmas); si es la misma y hay género, se afina el conteo en silencio
    if (g !== g0) apply(g, { save: false });
    else if (g) apply(g, { save: false, silent: true });
    sticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
